import { render, staticRenderFns } from "./problemInfo.vue?vue&type=template&id=60cad15d&scoped=true&"
import script from "./problemInfo.vue?vue&type=script&lang=js&"
export * from "./problemInfo.vue?vue&type=script&lang=js&"
import style0 from "./problemInfo.vue?vue&type=style&index=0&id=60cad15d&scoped=true&lang=css&"
import style1 from "./problemInfo.vue?vue&type=style&index=1&id=60cad15d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cad15d",
  null
  
)

export default component.exports